module.exports = __webpack_public_path__ + "static/media/taImg1.2cc5cf55.png";